import { Component, Input, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MicrosoftGraphService } from "../../services/microsoft-graph.service";
import { MsalService, MsalBroadcastService } from "@azure/msal-angular";
import {EventMessage, EventType, InteractionStatus} from "@azure/msal-browser";
import { filter } from "rxjs/operators";
import { ScheduleDataService } from "src/app/services/schedule-data.service";
import { Location } from "@angular/common";
@Component({
    selector: 'app-load-unload',
    templateUrl: 'load-unload.component.html',
    styleUrls: ['load-unload.css'],
    standalone: false
})
export class LoadUnloadComponent  implements OnInit{
    router: any;
    constructor(private location: Location,){
      
    }
    ngOnInit(): void {
        
    }

    Cancel() {
      this.location.back();
    }
}